import {useState, useEffect} from 'react';
import {Session} from '@supabase/supabase-js';
import {API, APIOptions} from '../classes/API';

export function useSession(token?: string, options?: APIOptions) {
  const [session, setSession] = useState<Session | null>(null);
  const [loading, setLoading] = useState(true);
  const supabase = API.getInstance(options).supabaseClient;

  useEffect(() => {
    async function initializeSession() {
      try {
        if (token) {
          // Set session with provided token
          const {data, error} = await supabase.auth.setSession({
            access_token: token,
            refresh_token: ' ', // Supabase requires a truthy value
          });

          if (error || !data.user) {
            setSession(null);
            localStorage.removeItem('token');
          } else {
            // Get the session after setting it
            const {
              data: {session: currentSession},
            } = await supabase.auth.getSession();
            setSession(currentSession);
          }
        } else {
          // Get current session
          const {
            data: {session: currentSession},
          } = await supabase.auth.getSession();
          setSession(currentSession);
        }
      } catch (error) {
        console.error('Error initializing session:', error);
        setSession(null);
      } finally {
        setLoading(false);
      }
    }

    initializeSession();

    // Listen for auth state changes
    const {
      data: {subscription},
    } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
      setLoading(false);
    });

    return () => subscription.unsubscribe();
  }, [supabase.auth, token]);

  const signIn = async (email: string, password: string) => {
    return await API.getInstance().signInWithEmail(email, password);
  };

  return {
    session,
    loading,
    signIn,
    user: session?.user ?? null,
  };
}
